// utils/fuzzyMatch.ts
import uFuzzy from '@leeoniya/ufuzzy'
import chunk from 'lodash/chunk'

export const fuzzyMatch = <T>(items: T[], keys: keyof T | (keyof T)[], search: string, opts: uFuzzy.Options = {}) => {
    const keyArr = Array.isArray(keys) ? keys : [keys]

    // stop-words FR + pronoms contractés
    const stop =
        /\b(?:j['’]\w+|t['’]\w+|je|tu|il|elle|nous|vous|ils|elles|le|la|les|un|une|des|de|du|mes|tes|ses|ont|est|sont|ai|as|avons|avez)\b/gi
    const cleaned = uFuzzy.latinize(
        search
            .replace(stop, '')
            .replace(/['’]/g, ' ') // enlève les apostrophes restantes
            .trim()
    )

    if (!cleaned) return items.map((item) => ({ item, ranges: [] }))

    const uf = new uFuzzy({
        intraMode: 1, // tolère 1 faute par mot
        intraIns: 1,
        interIns: Infinity,
        ...opts,
    })

    // on concatène titre + résumé
    const haystack = items.map((it) => uFuzzy.latinize(keyArr.map((k) => (it[k] as unknown as string) ?? '').join(' ')))

    // true → ordre des mots libre
    const [idxs, info] = uf.search(haystack, cleaned, 1)

    return (
        idxs?.map((idx, i) => ({
            item: items[idx],
            ranges: chunk(info?.ranges[i] || [], 2) as [number, number][],
        })) ?? []
    )
}

export const notFuzzyMatch = <T extends { keywords?: string[] }>(
  items: T[],
  keys: (keyof T)[],
  search: string
) => {
  const q = search.trim().toLowerCase()
  // empty search → return all items (no ranges)
  if (!q) {
    return items.map(item => ({ item, ranges: [] as [number,number][] }))
  }

  // 1️⃣ try keyword match
  const matches = items.filter(item => {
    const kws = item.keywords || []
    return kws.some(kw => {
      const k = kw.toLowerCase()
      return k.includes(q) || q.includes(k)
    })
  })

  // 2️⃣ map to the same shape { item, ranges }
  if (matches.length) {
    return matches.map(item => ({ item, ranges: [] as [number,number][] }))
  }

  // 3️⃣ no keyword hits → empty result
  return [] as { item: T; ranges: [number,number][] }[]
}